const timeExpirationInMinutes = 2880;

export {
  timeExpirationInMinutes
}


// WEBPACK FOOTER //
// ./src/constants/session-configuration.js